import httpClient from "./httpClient";
const getActiveUsers = (role = 'agent') =>
    httpClient.get("/api/users/getActiveUsers", {
      params: { role },
    });
export { getActiveUsers };
